import { lazy } from 'react';

const AuthRoutes = [
    {
        path: '/login',
        component: lazy(() => import('../../pages/Authentication/Login')),
        layout: 'BlankLayout',
        showNavbar: true,
        showFooter: true,
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/register',
        component: lazy(() => import('../../pages/Authentication/Register')),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/account/verify/:verificationCode',
        component: lazy(() =>
            import('../../pages/Authentication/AccountVerify'),
        ),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/forgot_password',
        component: lazy(() =>
            import('../../pages/Authentication/ForgotPassword'),
        ),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/reset-password/:passwordToken',
        component: lazy(() =>
            import('../../pages/Authentication/ResetPassword'),
        ),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/resend_verfication',
        component: lazy(() =>
            import('../../pages/Authentication/ResendVerification'),
        ),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
    {
        path: '/verify_and_login/:passwordToken/:verificationCode',
        component: lazy(() =>
            import('../../pages/Authentication/VerifyAndLogin'),
        ),
        layout: 'BlankLayout',
        meta: {
            authRoute: true,
        },
    },
];

export default AuthRoutes;
